// data.js
import image from '../assets/images/budgety.jpeg';
import image1 from '../assets/images/spaceHub.jpeg';
import image2 from '../assets/images/carBooking.PNG';

const projectsData = [
  {
    name: 'Budgety-App',
    demoImage: image,
    githubLink: 'https://github.com/aradradev/Budget-app',
    liveDemoLink: 'https://budgety-wbfb.onrender.com/',
    description: "Led the development of a budget management application in Ruby on Rails, offering users an intuitive tool for financial planning and tracking expenses. Received positive feedback for the app's simplicity and effectiveness in budget management.",
  },
  {
    name: "Space Traveler's Hub",
    demoImage: image1,
    githubLink: 'https://github.com/aradradev/space-traveler-s-hub',
    liveDemoLink: 'https://space-traveler-hub-project.netlify.app/',
    description: "Space Traveler's Hub is an application for a company that provides commercial and scientific space travel services. Built with React and Redux, this application allows users to book rockets and join selected space missions.",
  },
  {
    name: 'Car-booking Platform',
    demoImage: image2,
    githubLink: 'https://github.com/aradradev/car-booking-react',
    liveDemoLink: 'https://car-booking-frontend.onrender.com/',
    description: 'Engineered a robust car-booking platform using Ruby on Rails, providing users with a seamless booking experience. Achieved efficient data handling and user management, contributing to elevated customer satisfaction.',
  },
];

const experienceData = [
  {
    role: 'Microverse Graduate | Full-Stack Developer',
    company: 'Microverse',
    year: '2022 - Present',
    description: ' Led the development of robust RESTful APIs using Ruby, Ruby on Rails, and MySQL, ensuring seamless data integration and system functionality. Spending 789+ hours mastering algorithms, data structures, and front-end development while simultaneously developing projects with JavaScript, React, and Redux.',
  },
  {
    role: 'Volunteer mentoring',
    company: 'Microverse',
    year: '2023 - present',
    description: 'Providing mentorship to junior web developers and offering valuable insights and practical guidance on sustaining motivation for long-term success in the program, as well as strategies for maximizing learning from coding partners',
  },
];

export { projectsData, experienceData };
